const LEGACY_LAST_EMAIL_ID_KEY = 'lastEmailId';
const LEGACY_LAST_FETCH_KEY = 'quickEmailLastFetchAt';

function scopedKey(base, userId) {
  return userId != null && userId !== '' ? `${base}_${userId}` : base;
}

function readWithLegacy(scopedKeyName, legacyKey) {
  const value = localStorage.getItem(scopedKeyName);
  if (value != null) {
    return value;
  }
  if (scopedKeyName !== legacyKey) {
    const legacy = localStorage.getItem(legacyKey);
    if (legacy != null) {
      localStorage.setItem(scopedKeyName, legacy);
      return legacy;
    }
  }
  return null;
}

export function getLastEmailIdKey(userId) {
  return scopedKey(LEGACY_LAST_EMAIL_ID_KEY, userId);
}

export function getLastEmailId(userId) {
  const key = getLastEmailIdKey(userId);
  return readWithLegacy(key, LEGACY_LAST_EMAIL_ID_KEY) || '0';
}

export function setLastEmailId(userId, emailId) {
  const value = String(emailId);
  localStorage.setItem(getLastEmailIdKey(userId), value);
  localStorage.setItem(LEGACY_LAST_EMAIL_ID_KEY, value);
}

export function sweepEmailReadWatermark(userId, emailIds) {
  const current = parseInt(getLastEmailId(userId), 10) || 0;
  const maxId = (emailIds || []).reduce((max, id) => {
    const numeric = Number(id);
    return Number.isFinite(numeric) ? Math.max(max, numeric) : max;
  }, current);
  setLastEmailId(userId, maxId);
  return maxId;
}

export function getQuickEmailLastFetchKey(userId) {
  return scopedKey(LEGACY_LAST_FETCH_KEY, userId);
}

export function getQuickEmailLastFetchAt(userId) {
  const key = getQuickEmailLastFetchKey(userId);
  const raw = readWithLegacy(key, LEGACY_LAST_FETCH_KEY);
  if (!raw) {
    return null;
  }
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

export function setQuickEmailLastFetchAt(userId, timestamp = Date.now()) {
  localStorage.setItem(
    getQuickEmailLastFetchKey(userId),
    String(timestamp),
  );
}